import Login from './Login/Login'
import ForgotPassword from './ForgotPassword/ForgotPassword'
import SetPassword from './SetPassword/SetPassword'
import Register from './Register/Register'

export default function Auth (props = {
    data: null
}) {
    if (!Array.isArray(props.data)
            || !props.data.length)
        return null

    const components = {
        Login,
        ForgotPassword,
        SetPassword,
        Register
    }

    const isRegister = props.data
        .filter(obj => obj.type === 'Register')
        .length

    return (
        <section className="auth pad-section pad-4-t-lg-down">
            <div className="container">
                <div
                    className="row flex-justify-content-space-between"
                >
                    <div
                        className={`auth-content col-12 col-offset-1-xl-up ${
                            isRegister
                                ? 'col-7-lg col-6-xl-up'
                                : 'col-6-lg col-5-xl-up'}`}
                    >
                        {props.data
                            .filter(obj => obj.type
                                && components[obj.type])
                            .map((obj, idx) => {
                                const Component = components[obj.type]
                                return <Component key={`auth-${idx}`} {...obj} />
                            })}
                    </div>
                    <div className="col-4 display-none-lg-down">
                        <div className="auth-gfx">
                            <img
                                src="/images/gfx-arrow.svg"
                                width="455"
                                height="488"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
